export const environment = {
  production: false,
  urlMapping: {
    PROJ_API: 'https://kavach-pentest.vassardigital.ai/kavach/api/services',
    PROJ_API_URL: 'https://kavach-pentest.vassardigital.ai/kavach/api',
    SSE_URL: 'https://kavach-pentest.vassardigital.ai/api/sse/conversations',

    // PROJ_API: 'https://74348b1d501c.ngrok-free.app/api/kavach/services',
      USERMGMT_API:"https://kavach-pentest.vassardigital.ai/um/",
    //  WEBSOCKET_URL:"wss:/pentest.ce.vassardigital.ai/ws/chatbot/",
    DOMAIN_URL: "https://kavach-pentest.vassardigital.ai/"
  },
  KEYCLOAK_URLS: {
      BASE_URL: 'https://kavach-pentest.vassardigital.ai/auth',
      REDIRECT_URL: 'https://kavach-pentest.vassardigital.ai/landing',
      LOGOUT_URL: 'https://kavach-pentest.vassardigital.ai/login'
  },
       YOLO_CALLBACK_URL: "https://kavach-pentest.vassardigital.ai/kavach/api/services/yolo_callback",
    CLIENT_ID: 'kavachusermgmt',
    REALM_NAME: 'KavachUM'

};


